import { errorService } from 'global/services';

export const SUBSCRIPTION_TYPES = {
    sbpSinglePay: 'sbpSinglePay',
    singlePay: 'singlePay',
    subscription: 'subscription',
};

export const DEFAULT_SUBSCRIPTION_TYPE = SUBSCRIPTION_TYPES.subscription;

export const isSubscription = (subscriptionType) => SUBSCRIPTION_TYPES.subscription === subscriptionType;

export const getInitilaSubsctiptionType = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const payment = urlParams.get('payment');

        switch (payment) {
            case 'online':
                return SUBSCRIPTION_TYPES.singlePay;
            case 'sbp':
                return SUBSCRIPTION_TYPES.sbpSinglePay;
            default:
                return SUBSCRIPTION_TYPES.subscription;
        }
    } catch (error) {
        errorService.log({
            text: 'get initila SubsctiptionType error',
            source: 'client',
            error,
        });
        return SUBSCRIPTION_TYPES.subscription;
    }
};

export const getInitilaPaymentMethod = (selectedPeriod = null) => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const payment = urlParams.get('payment');

        switch (payment) {
            case 'online':
                return 'online';
            case 'sbp':
                return 'sbp';
            default:
                return 'recurrent';
        }
    } catch (error) {
        errorService.log({
            text: 'get initila SubsctiptionType error',
            source: 'client',
            error,
        });
        return SUBSCRIPTION_TYPES.subscription;
    }
};

